// src/features/attendance/services/attendanceService.js
import api, { BASE_URL } from "../../../utils/api";
import { queueAttendancePunch } from "./offlineAttendanceQueue";

// ---- existing demo for Attendance Requests (keep it) ----
const demoRows = [
  {
    id: 1,
    employee: { code: "E-1001", punch: "1001", name: "Sumitha Thomas" },
    date: "2024-08-10",
    changeType: "In/Out Adjust",
    status: "Pending",
    details: "Late arrival due to traffic",
    approvals: "Line Mgr",
    addedOn: "2024-08-10 09:15",
  },
];

export async function fetchAttendanceRequests(filters) {
  await new Promise((r) => setTimeout(r, 200));
  return demoRows;
}

// ---- NEW: attendance core APIs ----
export async function getAttendanceOffices() {
  const { data } = await api.get("/attendance/offices");
  return data.offices || [];
}

export async function getTodayAttendance() {
  const { data } = await api.get("/attendance/today");
  return data;
}

export async function punchAttendance({
  office_id,
  punch_type,
  employee_id,
  note,
  clientTime,
  latitude,
  longitude,
  accuracy,
  photo,
  face_descriptor,
  biometric_verified
}) {
  const payload = {
    office_id,
    punch_type,
    employee_id,
    note,
    clientTime,
    latitude,
    longitude,
    accuracy,
    photo,
    face_descriptor,
    biometric_verified,
  };

  try {
    const { data } = await api.post("/attendance/punch", payload);
    return data;
  } catch (error) {
    if (!error.response) {
      const queued = queueAttendancePunch(payload);
      return {
        queued: true,
        queue_id: queued.id,
        message: "Internet unavailable. Punch saved on this device and will retry automatically.",
      };
    }
    throw error;
  }
}

// HR/Admin
export async function getAdminMissingAttendance(date) {
  const { data } = await api.get("/attendance/admin/missing", {
    params: { date },
  });
  return data;
}

// --- Super Admin settings ---
export async function getAttendanceShifts() {
  const { data } = await api.get("/attendance/settings/shifts");
  return data.shifts || [];
}

export async function updateAttendanceShift(id, payload) {
  const { data } = await api.put(`/attendance/settings/shifts/${id}`, payload);
  return data;
}

export async function getAttendanceRules() {
  const { data } = await api.get("/attendance/settings/rules");
  return data.rules || [];
}

export async function updateActiveAttendanceRule(payload) {
  const { data } = await api.put("/attendance/settings/rules/active", payload);
  return data;
}

export async function bulkAssignAttendanceShift(payload) {
  const { data } = await api.post("/attendance/settings/shifts/bulk-assign", payload);
  return data;
}

export async function getOfficialHolidays() {
  const { data } = await api.get("/attendance/settings/official-holidays");
  return data;
}

export async function createOfficialHoliday(payload) {
  const { data } = await api.post("/attendance/settings/official-holidays", payload);
  return data;
}

export async function deleteOfficialHoliday(id) {
  const { data } = await api.delete(`/attendance/settings/official-holidays/${id}`);
  return data;
}

export async function getPersonalAttendanceSummary() {
  const { data } = await api.get("/attendance/summary/personal");
  return data;
}

export async function getMonthlyAttendanceReport(params) {
  const { data } = await api.get("/attendance/report/monthly", { params });
  return data;
}

export async function getAuditLocations() {
  const { data } = await api.get("/attendance/audit-locations");
  return data;
}

export async function getAttendanceLogs(date) {
  const { data } = await api.get("/attendance/logs", {
    params: { date },
  });
  return data;
}

export function getAttendanceLogsExcelUrl(date) {
  return `${BASE_URL}/api/v1/attendance/logs?date=${date}&format=excel`;
}
